export * from './layout';
export * from './notification';

import { LayoutComponents } from './layout';
import { NotificationComponents } from './notification';

export const Components = [
    ...LayoutComponents,
    ...NotificationComponents
];